// extracted by mini-css-extract-plugin
export default {"card":"Card_card__EQg8I","imageWrapper":"Card_imageWrapper__ySuo1","image":"Card_image__z-ru2","title":"Card_title__tavu7","desc":"Card_desc__a1IqQ"};